"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Calculates the aspect ratio of an image
 * accounting for a
 *
 * @param dimensions The dimensions of the image.
 * @param crop       The crop dimensions of the image.
 * @param percentage If `true`, the aspect ratio will be returned as a percentage value.
 */
function calculateAspectRatio(dimensions, crop, percentage) {
    if (crop === void 0) { crop = { width: 100, height: 100 }; }
    if (percentage === void 0) { percentage = false; }
    var width = dimensions.width, height = dimensions.height;
    var cropWidth = crop.width, cropHeight = crop.height;
    if (typeof width !== 'number' || typeof height !== 'number') {
        return percentage ? 100 : 1;
    }
    var ratio = (width * (cropWidth || 100 / 100)) / (height * (cropHeight || 100 / 100)) ||
        1;
    return percentage ? 100 / ratio : 1;
}
exports.default = calculateAspectRatio;
//# sourceMappingURL=calculateAspectRatio.js.map